import { PrintTransport, DesktopDocumentType } from './printing.types';

export class PrintTransportSelector {
  constructor(
    private readonly desktop: PrintTransport,
    private readonly qz: PrintTransport
  ) {}

  async select(documentType: DesktopDocumentType): Promise<PrintTransport> {
    return (await this.desktop.isAvailable(documentType)) ? this.desktop : this.qz;
  }
}
